var _mask, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcnFashion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 11,
    viewBox: "0 0 15 11",
    width: 15,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h14.949v10.956h-14.949z",
    fill: "#fff",
    fillRule: "evenodd"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m7.476 8.99 6.25-1.164c.098-.019.198-.034.294-.062.05-.015.094-.056.14-.085-.031-.047-.058-.097-.095-.14-.021-.025-.055-.042-.087-.056-.212-.093-.419-.203-.638-.273-2.154-.693-4.31-1.379-6.466-2.07-.082-.026-.138-.015-.205.04-1.393 1.12-2.789 2.24-4.182 3.36-.452.363-.907.725-1.35 1.1-.136.116-.248.266-.35.416-.07.102-.026.161.097.151.107-.008.214-.028.32-.048l6.273-1.169m.135.753c-2.083.388-4.165.778-6.25 1.162-.203.037-.414.057-.62.05-.559-.018-.868-.484-.691-1.017.128-.388.36-.705.672-.96.896-.726 1.796-1.448 2.696-2.17.908-.73 1.815-1.46 2.727-2.184.086-.068.09-.127.077-.224-.031-.238-.055-.477-.057-.716-.002-.163.083-.3.193-.425.452-.511.673-1.112.632-1.796-.027-.444-.227-.69-.701-.69-.093 0-.186.01-.277.025-.29.048-.56.145-.778.356-.268.261-.354.593-.357.954 0 .081.01.163.02.244.032.244-.1.432-.328.465-.22.032-.391-.1-.424-.345-.102-.767.068-1.445.67-1.97.196-.173.427-.29.678-.367.42-.127.846-.193 1.277-.067.459.134.758.444.892.9.23.783.05 1.516-.318 2.212-.108.204-.267.38-.395.573-.029.043-.043.109-.037.16.015.136.04.27.074.402.01.036.061.075.101.088.724.234 1.449.464 2.173.695 1.505.481 3.01.96 4.513 1.446.383.123.711.337.97.652.36.437.236.986-.285 1.204-.188.078-.388.136-.587.173-2.086.394-4.173.78-6.26 1.17",
    fill: "#2c2c2c",
    fillRule: "evenodd",
    mask: "url(#a)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnFashion);
export default __webpack_public_path__ + "static/media/icn_fashion.29365b861e7fb2cb9868c09ca23ecb9b.svg";
export { ForwardRef as ReactComponent };